'use strict';

exports.__esModule = true;
exports.default = extractPropertyFromState;

var _extractPropertyFromFields = require('./extractPropertyFromFields');

var _extractPropertyFromFields2 = _interopRequireDefault(_extractPropertyFromFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function extractPropertyFromState(state, formName, property) {
  return (0, _extractPropertyFromFields2.default)(state.onionForm.getIn(['fields', formName]) || [], property);
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/onion-form/lib/extractPropertyFromState.js
// module id = 125
// module chunks = 0